<template>
    <div :class="$style.paneWrapper" >
        <div
            :class="$style.closeIcon"
            tabindex="0"
            role="button"
            aria-label="close dialog"
            @click="close"
            @keyup.enter="close"
            @keydown.esc="close"
            ref="closeIcon"
        >
            <FontAwesomeIcon :icon="faTimes" />
        </div>
        <JobDescription :job="job" />
    </div>
</template>

<script>
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faTimes } from '@fortawesome/pro-light-svg-icons'
import JobDescription from '../JobDescription.vue'
import mapIcons from '@/utils/mapIcons'

export default {
    name: 'JobDescriptionPane',
    components: {
        FontAwesomeIcon,
        JobDescription,
    },
    props: {
        job: {
            type: Object,
            required: true,
        }
    },
    computed: {
        ...mapIcons({ faTimes }),
    },
    methods: {
        close() {
            this.$emit('close')
        },
    },
}
</script>

<style module src="./JobDescriptionPane.css" />
